import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const TotalsCounter = styled.div`
  color: #8c8c8c;
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
`
